import React, { useState } from 'react';
import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'
import {ReactComponent as SearchIcon} from '../../components/svgs/searchicon.svg';
import {ReactComponent as ExportIcon} from '../../components/svgs/exportIcon.svg';
import { Link } from 'react-router-dom';


// const options = [
//     { label: 'Edit Order', link: '#' },
//     { label: 'Duplicate Order', link: '#' },
//     { label: 'Print Details', link: '#' },
//     { label: 'Archive Orders', link: '#' }
//   ];



const OwnerServicesTab = () => {

    const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: 'Active',
    
      tableData: [
        { serviceName: 'Wash n Fold', unitOfMeasure: 'Per pound', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/services/services-details' },
        { serviceName: 'Same Day Service', unitOfMeasure: 'Per pound', pricePerUnit: '$2.99', minimumSize: '10lbs', viewButton: '/owner/services/services-details' },
        { serviceName: 'Large Bag', unitOfMeasure: 'Per item', pricePerUnit: '$10.00', minimumSize: '--', viewButton: '/owner/services/services-details' },
        { serviceName: 'Lab Coat', unitOfMeasure: 'Per item', pricePerUnit: '$5.00', minimumSize: '--', viewButton: '#' },
        { serviceName: 'Blanket', unitOfMeasure: 'Per item', pricePerUnit: '$10.00', minimumSize: '--', viewButton: '#' },
        { serviceName: 'Throw Pillows', unitOfMeasure: 'Per item', pricePerUnit: '$4.00', minimumSize: '--', viewButton: '#' },
        
      ]
    },
    {
      title: 'Archived',
    
      tableData: [
        { serviceName: 'Wash n Fold', unitOfMeasure: 'Per pound', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/manager/services/services-details' },
        { serviceName: 'Same Day Service', unitOfMeasure: 'Per pound', pricePerUnit: '$2.99', minimumSize: '10lbs', viewButton: '#' },
        { serviceName: 'Large Bag', unitOfMeasure: 'Per item', pricePerUnit: '$10.00', minimumSize: '10lbs', viewButton: '#' },
        { serviceName: 'Lab Coat', unitOfMeasure: 'Per item', pricePerUnit: '$5.00', minimumSize: '10lbs', viewButton: '#' },
        { serviceName: 'Blanket', unitOfMeasure: 'Per item', pricePerUnit: '$10.00', minimumSize: '10lbs', viewButton: '#' },
        // { serviceName: 'Throw Pillows', unitOfMeasure: 'Per item', pricePerUnit: '$4.00', minimumSize: '10lbs', viewButton: '#' },
      ]
    },
  
  ];


  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <>
    <div className="tab-container">

        <div className="tab-titles mb-6">
            {tabs.map((tab, index) => (
                <div
                key={index}
                className={`tab-title ${activeTab === index ? 'active' : ''}`}
                onClick={() => handleTabClick(index)}
                >
            
                <div className={`tab-label tab-without-icon ${activeTab === index ? 'active' : ''}`}>{tab.title}</div>
                </div>
            ))}
        </div>

        <section className='flex search-filter-section mt-4 mb-4 ml-4'>
            <section>
                <form action="">
                <label htmlFor="" className="flex flex-col order-search-input">
                    <SearchIcon className='order-search-icon search-icon'/>
                    <input type="text" placeholder="Search" className="mt-2"/>
                </label>
                </form>
            </section>
            <section className='flex gap-10 mt-10 ml-48'>
                <div className='flex gap-4'>
                    <ExportIcon/>
                    <p className='filter-section-text'>Export as csv</p>
                    
                </div>
            </section>
        </section>    
            

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div key={index} className={`tab-pane ${activeTab === index ? 'active' : ''}`}>
            <table className="custom-table custom-order-table">

              <thead>
                <tr className='table-head'>
                  <th className=''>
                    Service name
                    <span className="filter-icon">
                      <ActiveIcon />
                      
                    </span>
                  </th>
                  <th className=''>
                    Unit of measure
                    <span className="filter-icon">
                    <ActiveIcon className=''/>
                    </span>
                  </th>
                  <th>
                    Price per unit
                    <span className="filter-icon">
                    <ActiveIcon />
                    </span>
                  </th>
                  <th>
                    Minimum size
                    <span className="filter-icon">
                      <ActiveIcon />
                    </span>
                  </th>
                  
                </tr>
              </thead>

              <tbody className='table-body'>
                {tab.tableData.map((data, dataIndex) => (
                  <tr key={dataIndex} className='table-row'>
                    <td className='table-data-1'>
                      {data.serviceName}
                      
                    </td>
                   
                    <td className='table-data-1'>
                      {data.unitOfMeasure}
                      <div className='customer-rep'>{data.commercialCustomerRep}</div>
                    </td>
                   
                    <td className='table-data'>
                      {data.pricePerUnit}
                    
                    </td>
                    <td className='table-data'>
                      {data.minimumSize}
                    
                    </td>
                    <td>
                        <Link to={data.viewButton} className='view-btn'>View</Link>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default OwnerServicesTab